(function () {
  if (window.__invCardCarousel) return;
  window.__invCardCarousel = true;

  function getSlideCount(carousel) {
    return carousel.querySelectorAll('[data-carousel-slide]').length;
  }

  function goTo(carousel, index) {
    var count = getSlideCount(carousel);
    if (count <= 1) return;

    if (index < 0) index = count - 1;
    if (index > count - 1) index = 0;

    carousel.setAttribute('data-carousel-index', index);

    var track = carousel.querySelector('[data-carousel-track]');
    if (track) {
      track.style.transform = 'translateX(' + -index * 100 + '%)';
    }

    var scope = carousel.closest('.card-wrapper') || carousel;
    var dots = scope.querySelectorAll('[data-carousel-dot]');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function currentIndex(carousel) {
    return parseInt(carousel.getAttribute('data-carousel-index'), 10) || 0;
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-carousel-prev]');
    var next = event.target.closest('[data-carousel-next]');
    var dot = event.target.closest('[data-carousel-dot]');
    if (!prev && !next && !dot) return;

    var scope = event.target.closest('[data-card-carousel]') || event.target.closest('.card-wrapper');
    var carousel = scope ? (scope.matches('[data-card-carousel]') ? scope : scope.querySelector('[data-card-carousel]')) : null;
    if (!carousel) return;

    event.preventDefault();
    event.stopPropagation();

    if (prev) {
      goTo(carousel, currentIndex(carousel) - 1);
    } else if (next) {
      goTo(carousel, currentIndex(carousel) + 1);
    } else if (dot) {
      goTo(carousel, parseInt(dot.getAttribute('data-carousel-dot'), 10) || 0);
    }
  });

  /* InVogue (Oct 2026): swipe between card images (the arrows are hidden). A horizontal swipe
     changes image; the tap that ends a swipe does not open the product. */
  var touch = null;
  var swiped = 0;
  document.addEventListener('touchstart', function (event) {
    var carousel = event.target.closest('[data-card-carousel]');
    if (!carousel || getSlideCount(carousel) <= 1 || event.touches.length !== 1) { touch = null; return; }
    touch = { c: carousel, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (!touch) return;
    var t = event.changedTouches[0];
    var dx = t.clientX - touch.x, dy = t.clientY - touch.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      goTo(touch.c, currentIndex(touch.c) + (dx < 0 ? 1 : -1));
      swiped = Date.now();
    }
    touch = null;
  }, { passive: true });
  document.addEventListener('click', function (event) {
    if (swiped && Date.now() - swiped < 400 && event.target.closest('[data-card-carousel]')) {
      event.preventDefault();
      event.stopPropagation();
      swiped = 0;
    }
  }, true);
})();
